export default {
	data() {
		return {
		}
	},
	mounted() {
		try {
				// this.$util.browseRecord(1,this)
		}catch (e) {
//
		}
	},
	beforeDestroy(){
		try {
				// this.$util.browseRecord(2,this,this.browseId)
		}catch (e) {
//
		}
	},
	methods: {
    /**
		 * 重新渲染el-table组件样式
		 * 用于处理刷新页面后配置 fixed="right" 的列出现样式错误的问题
		 * @param {value} ref 参数 
		 * @returns null
		 */
    doLayout(value) {
      if (!value) return
      this.$nextTick(() => {
        this.$refs[value].doLayout();
      });
    },
	}
}
